import React, { useState } from "react";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../PermissionsConstants";
import { LeasedEquipmentTable } from "./view/LeasedEquipmentTable";

interface Props {}

export const LeasedEquipment: React.FC<Props> = () => {
  const viewPermission = PERMISSIONS.permission_leasedequipment_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>
      {userPermissions.includes(viewPermission) ? <LeasedEquipmentTable /> : ""}
    </>
  );
};
